import { pointFrom } from "@excalidraw/math";

import { getNonDeletedElements } from "@excalidraw/element";
import { distanceToElement } from "@excalidraw/element";
import { elementCenterPoint } from "@excalidraw/element";

import { CaptureUpdateAction } from "@excalidraw/element";

import type { GlobalPoint } from "@excalidraw/math";

import { centerScrollOn } from "../scene/scroll";

import { register } from "./register";

export const actionCenterOnScreen = register({
  name: "centerOnScreen",
  label: "labels.centerOnScreen",
  trackEvent: { category: "canvas" },
  perform: (elements, appState, _, app) => {
    const nonDeletedElements = getNonDeletedElements(elements);

    if (nonDeletedElements.length === 0) {
      return false;
    }

    const { x: sceneX, y: sceneY } = app.lastContextMenuScenePosition;
    const cursorPoint = pointFrom<GlobalPoint>(sceneX, sceneY);

    const elementsMap = app.scene.getNonDeletedElementsMap();

    let nearestElement = nonDeletedElements[0];
    let minDistance = Infinity;

    for (const element of nonDeletedElements) {
      const dist = distanceToElement(element, elementsMap, cursorPoint);
      if (dist < minDistance) {
        minDistance = dist;
        nearestElement = element;
      }
    }

    const center = elementCenterPoint(nearestElement, elementsMap);

    const { scrollX, scrollY } = centerScrollOn({
      scenePoint: { x: center[0], y: center[1] },
      viewportDimensions: {
        width: appState.width,
        height: appState.height,
      },
      zoom: appState.zoom,
      offsets: app.getEditorUIOffsets(),
    });

    return {
      appState: {
        ...appState,
        scrollX,
        scrollY,
      },
      captureUpdate: CaptureUpdateAction.EVENTUALLY,
    };
  },
  predicate: (elements) => {
    return getNonDeletedElements(elements).length > 0;
  },
});
